import React, { Fragment, useState, useEffect, useMemo, useContext } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useSelector, useDispatch } from "react-redux";
import fuzzy from "fuzzy";
import Cookies from "js-cookie";

import "react-perfect-scrollbar/dist/css/styles.css";
import { CatalogueLeftSectionWrapper, CataloguePageWrapper } from "./components/catalogue.styles";
import HeaderSection from "./components/HeaderSection";
import CatalogueItems from "./components/CatalogueItems";
import OrderDetails from "./components/orderDetails/OrderDetails";
import MobileChargeButton from "./components/MobileChargeButton";
import MobileOrderDetails from "./components/orderDetails/MobileOrderDetails";
import { useFetchSalesItems } from "../../../common/hooks/useFetchSalesCatalogueData";
import { DashboardLoaderWrap } from "../../../../AuthenticatedApp/components/productCatalogue/dashboard/dashboard.styles";
import Loader from "../../../../../library/Loader";
import { createSalesOrder } from "../../../../../redux/actions/salesOrder.acton";
import { ActionTypes, ChargeItemsContext } from "../context";

const ItemsPage = () => {
    const [activeMobileView, setActiveMobileView] = useState(0);
    const [searchString, setSearchString] = useState("");
    const [width, setWidth] = useState();

    const { state, contextDispatch } = useContext(ChargeItemsContext);

    const { catalogueItems, itemsState } = useSelector((state) => state.catalogueState);
    const [filteredItems, setFilteredItems] = useState(catalogueItems);

    const dispatch = useDispatch();

    const handleGetItems = useFetchSalesItems();
    const handleMobileCharge = () => {
        setActiveMobileView(1);
    };

    const handleGoBack = () => {
        setActiveMobileView(0);
    };

    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    };

    const searchedItems = useMemo(() => {
        if (!searchString) return filteredItems;
        const options = {
            extract: function (el) {
                return `${el.name} ${el.unitPrice}`;
            },
        };
        const result = fuzzy.filter(searchString, filteredItems, options);
        return result.map((el) => el.original);
    }, [searchString, filteredItems]);

    const handleFilterByCategory = (filterItem) => {
        if (filterItem.id === 0) {
            setFilteredItems(catalogueItems);
        } else {
            const updatedItems = catalogueItems.filter(
                (item) => item.category.id === filterItem.id,
            );
            setFilteredItems(updatedItems);
        }
    };

    const handleCreateOrder = async (initialItem) => {
        const groupCustomerId = Cookies.get("groupCustomerId");
        const deviceName = Cookies.get("deviceName");
        const deviceID = Cookies.get("deviceID");

        const auditLog = {
            moduleName: "Catalogue",
            action: "Create Order",
            description: "Create order for a catalogue",
        };
        const payload = {
            ...auditLog,
            ownerID: groupCustomerId,
            SaleDeviceID: deviceID,
            SaleDeviceName: deviceName,
            items: [
                {
                    id: initialItem.id,
                    quantity: 1,
                },
            ],
        };

        try {
            const { status, data } = await dispatch(createSalesOrder(payload));
            if (status) {
                contextDispatch({
                    type: ActionTypes.INITIATE_ORDER,
                    payload: {
                        id: data?.id,
                        orderID: data?.orderID,
                    },
                });
            }
        } catch (err) {}
    };

    useEffect(() => {
        handleGetItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setFilteredItems(catalogueItems);
    }, [catalogueItems]);

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    useEffect(() => {
        if (width > 768) {
            setActiveMobileView(0);
        }
    }, [width]);
    const totalPrice = useMemo(
        () => state?.itemsState?.reduce((total, item) => total + item.currentPrice, 0),
        [state],
    );

    if ((itemsState === "idle" || itemsState === "loading") && !catalogueItems) {
        return (
            <DashboardLoaderWrap>
                <Loader />
            </DashboardLoaderWrap>
        );
    }
    return (
        <Fragment>
            {activeMobileView === 0 && (
                <>
                    <CataloguePageWrapper>
                        <CatalogueLeftSectionWrapper>
                            <PerfectScrollbar style={{ maxHeight: "100%", paddingRight: "16px" }}>
                                <HeaderSection
                                    {...{
                                        searchString,
                                        setSearchString,
                                        catalogueItems,
                                        handleFilterByCategory,
                                    }}
                                />
                                <CatalogueItems {...{ searchedItems, handleCreateOrder }} />
                            </PerfectScrollbar>
                        </CatalogueLeftSectionWrapper>
                        <OrderDetails {...{ totalPrice }} />
                    </CataloguePageWrapper>
                    <MobileChargeButton {...{ handleMobileCharge, totalPrice }} />
                </>
            )}
            {activeMobileView === 1 && (
                <CataloguePageWrapper>
                    <MobileOrderDetails {...{ handleGoBack, totalPrice }} />
                </CataloguePageWrapper>
            )}
        </Fragment>
    );
};
export default ItemsPage;
